export const kds = {
	emptyKdsDescription:
		"El KDS aún no ha sido creado. Cuando esté disponible, se mostrará aquí.",
	editKds: "Sus cambios han sido guardados.",
	title: "Configuración del KDS",
	subtitle: "Configure el KDS para mejorar y organizar las operaciones de su cocina.",
	createdAt: "Creado en",
	seeKds: "Visualizar KDS",
	linkedBar: "Bar vinculado",
	basic: "Básico",
	main: "Principal",
	general: "General",
	mainTooltip:
		"El KDS Principal centraliza el control de pedidos, permitiendo cambiar estado, cancelar, visualizar cancelaciones y dar seguimiento a todos los pedidos.",
	basicTooltip:
		"El KDS Básico muestra todos los pedidos dirigidos a él con estado abierto y completado, sin permitir cambios o visualización de cancelaciones.",
	confirmModal: {
		title: "Tiene cambios sin guardar",
		description:
			"Para salir de la página sin perder el progreso, guarde sus cambios. Si continúa sin guardar, todos los cambios se perderán.",
		close: "Salir sin guardar",
	},
	form: {
		name: "Nombre del KDS",
		linkedBar: "Bar vinculado",
		status: "Cambio de estado",
		timeManagement: "Gestión de tiempo",
		readyTimeOrderLabel: "Tiempo para que un pedido sea considerado listo",
		standardTimeOrderLabel: "Tiempo estándar por pedido (min.)",
		originOrder: "Origen del pedido (Delivery y otras integraciones)",
		orderNumber: "Número del pedido",
		customerName: "Nombre del cliente",
		saveChanges: "Guardar cambios",
		generalSettings: "Configuración general",
		timeSettings: "Configuración de tiempo",
		orderCardSettings: "Configuración de la tarjeta de pedido",
	},
	statusChangeTypes: {
		auto: "Automáticamente",
		manual: "Manualmente",
	},
	timeManagementTypes: {
		byProduct: "Utilizar tiempo por producto de la integración",
		defaultTime: "Utilizar un estándar por pedido",
		noManagement: "No utilizar tiempo",
	},
	zigKds: {
		title: "Gestión de KDS",
		description: "Gestiona tus KDS, vincula productos a pantallas y rastrea pedidos.",
		searchPlaceholder: "Buscar por...",
		createNew: "Crear nuevo",
		card: {
			linkedBarLabel: "Bar(es) vinculado(s):",
			linkedProductsLabel: "Productos Vinculados",
			editButton: "Editar",
			addScreenButton: "Agregar pantalla",
			editScreen: "Editar pantalla",
			deleteScreen: "Eliminar pantalla",
			primary: "Primario",
			secondary: "Secundario",
		},
		emptyState: {
			createNewKds: "Crear un nuevo KDS",
			title: "Ningún KDS configurado aún",
			description:
				"Aún no tienes ningún KDS. Registra y configura uno para rastrear tus pedidos en pantallas.",
			noSearchResults: {
				title: "KDS no encontrado",
				description:
					"No encontramos ningún KDS con los términos buscados. Intenta ajustar tu búsqueda.",
			},
		},
		deleteScreenModal: {
			title: "Eliminar pantalla",
			confirmText:
				"¿Estás seguro de que deseas <highlight>eliminar</highlight> la pantalla {{screenName}}?",
			warningText:
				"Al confirmar, todos los productos asociados a esta pantalla serán eliminados.",
			cancelButton: "Volver",
			confirmButton: "Confirmar",
		},
		drawer: {
			createTitle: "Crear nuevo KDS",
			editTitle: "Editar KDS",
			backButton: "Volver",
			saveButton: "Guardar",
			deleteButton: "Eliminar KDS",
		},
		deleteKdsModal: {
			title: "Eliminar KDS",
			confirmText:
				"¿Estás seguro de que deseas <highlight>eliminar</highlight> el KDS {{kdsName}}?",
			warningText:
				"Al confirmar, todas las pantallas vinculadas y productos asociados a este KDS serán eliminados.",
			backButton: "Volver",
			confirmButton: "Confirmar",
		},
		configForm: {
			kdsNameLabel: "Nombre del KDS",
			kdsNamePlaceholder: "Describe el nombre del nuevo KDS",
			linkedBarsLabel: "Bar(es) vinculado(s)",
			linkedBarsPlaceholder: "Selecciona uno o más bares para vincular",
			productsDisplayedLabel: "Productos mostrados",
			productsDisplayedDescription:
				"Lista de todos los productos del bar que pueden ser mostrados en este KDS.",
			emptyProductsTitle: "Ningún producto mostrado aún",
			emptyProductsBullet1:
				"Registra productos en el bar vinculado para que aparezcan aquí.",
			emptyProductsBullet2: "Vincula este KDS a un bar para cargar los productos.",
			goToBarsButton: "Ir a bares y sectores",
			products: "productos",
		},
		tabs: {
			configuration: "Configuración",
			statusAndTime: "Estado y Tiempo",
		},
		generalSettings: {
			timeManagementTitle: "Gestión de tiempo",
			statusUpdateTitle: "Actualización del estado del pedido",
			cardInfoTitle: "Información mostrada en la tarjeta del pedido",
		},
		printing: {
			title: "Impresiones",
			toggleLabel: "Imprimir pedido al marcar como hecho",
			toggleDescription:
				"Al concluir un pedido en este KDS, se imprime automáticamente en las impresoras asociadas.",
			associatedPrintersTitle: "Impresoras asociadas",
			ipLabel: "IP de la impresora",
			ipPlaceholder: "Ingresa la IP",
			nicknameLabel: "Apodo",
			nicknamePlaceholder: "Ingresa el nombre de la impresora. Ej.: Expedición - barra",
			addPrinter: "+ Agregar impresora",
			errors: {
				duplicateIp: "Esta IP ya está asociada a este KDS.",
			},
		},
		screensPanel: {
			configuredScreensLabel: "Pantallas configuradas",
			addScreenButton: "Agregar pantalla",
			unsavedWarningTitle: "KDS Principal No Guardado",
			unsavedWarningMessage:
				"Para poder <strong>editar o agregar nuevas pantallas</strong>, necesitas <strong>guardar la configuración del KDS Principal a continuación.</strong>",
			productsLabel: "Productos",
		},
		productsPreview: {
			searchPlaceholder: "Buscar por producto o categoría",
			loadingMessage: "Cargando productos...",
			noResultsMessage: "No se encontraron productos para la búsqueda.",
			noProductsMessage: "No se encontraron productos para el bar seleccionado.",
		},
		settings: {
			timeSettings: {
				timerEnabled: {
					label: "Cronómetro de tiempo del pedido",
					description:
						"Cuenta el tiempo del pedido desde la creación hasta ser finalizado.",
				},
				productionTimeEnabled: {
					label: "Tiempo de producción por producto",
					description: "Muestra el tiempo estimado de preparación de cada producto.",
				},
			},
			cardInfoSettings: {
				showOrderNumber: {
					label: "Número del pedido",
					description: "Muestra el identificador único del pedido.",
				},
				showOrigin: {
					label: "Origen",
					description: "Indica de dónde se realizó el pedido (POS, delivery, etc.).",
				},
				showOrderTime: {
					label: "Hora del pedido",
					description: "Muestra la hora en que se creó el pedido",
				},
				showCustomerTable: {
					label: "Cliente/Mesa",
					description: "Muestra el nombre del cliente o el número de mesa.",
				},
				showProductionTimeCard: {
					label: "Tiempo de producción por producto",
					description: "Muestra el tiempo estimado de preparación de cada artículo.",
				},
				showObservation: {
					label: "Observación",
					description: "Muestra observaciones adicionales del pedido.",
				},
			},
			statusModeOptions: {
				manual: {
					label: "Manual",
					description: "Permite avanzar el estado del pedido manualmente",
				},
				automatic: {
					label: "Automático",
					description:
						"Permite avanzar el estado del pedido después de un tiempo definido",
				},
			},
		},
		notifications: {
			kdsCreated: "KDS creado con éxito",
			kdsEdited: "KDS editado con éxito",
			kdsDeleted: "KDS eliminado con éxito",
			screenDeleted: "Pantalla eliminada con éxito",
		},
	},
	report: {
		title: "Reporte de producción",
		description:
			"Acompañe el desempeño de los sectores de producción, identifique cuellos de botella y oportunidades de mejora.",
		exportButton: "Exportar",
		exportNotification:
			"El reporte se está generando y se enviará a {{email}} cuando esté listo.",
		exportError: "No se pudo generar el reporte. Inténtalo de nuevo.",
		tabs: {
			overview: "Visión general",
			products: "Productos",
			orders: "Pedidos",
		},
		filters: {
			kds: "Filtrar por KDS",
			screen: "Filtrar por pantalla",
			source: "Filtrar por origen del pedido",
			category: "Filtrar por categoría del producto",
			product: "Filtrar por producto",
		},
		productsTable: {
			product: "Producto",
			category: "Categoría",
			quantity: "Cantidad",
			expectedTime: "Tiempo esperado",
			actualTime: "Tiempo promedio de prod.",
			variation: "Variación",
			empty: "No se encontraron datos para el período seleccionado.",
			error: "Error al cargar los datos. Intente nuevamente.",
		},
		ordersTable: {
			dateTime: "Fecha y Hora",
			orderId: "ID del Pedido",
			source: "Origen del Pedido",
			kdsName: "Recibido en",
			totalTime: "Tiempo Total del Pedido",
			finalStatus: "Estado Final",
			delayed: "Atrasado",
			onTime: "A Tiempo",
			empty: "No hay pedidos en el período seleccionado.",
			error: "Error al cargar los datos. Intente nuevamente.",
			infoText: "Para más detalles sobre los pedidos, acceda al Reporte de ventas.",
		},
		ordersFilters: {
			orderPassword: "Buscar por ID del pedido",
			finalStatus: "Filtrar por estado final",
			finalStatusDelayed: "Atrasado",
			finalStatusOnTime: "A Tiempo",
		},
		overviewPlaceholder: {
			title: "¡Estamos preparando todo!",
			description:
				"Pronto podrás ver gráficos para analizar tiempos de producción, retrasos, etc.",
		},
	},
};
